import { useState } from "react"
import {
  Button,
  IconButton,
  Logo,
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@motleyhand/design"
import { Link } from "@tanstack/react-router"
import { Menu01Icon } from "@hugeicons/core-free-icons"
import { hasStories } from "./stories"
import { ButtonLink } from "@/base"
import { useAuth } from "@/auth"

function NavLinks({ onNavigate }: { onNavigate?: () => void }) {
  const { isAuthenticated } = useAuth()

  const ctaProps = isAuthenticated
    ? { to: "/dashboard" as const, children: "Dashboard" }
    : { to: "/auth" as const, children: "Start Free" }

  return (
    <>
      <ButtonLink to="/" hash="features" variant="ghost" onClick={onNavigate}>
        Features
      </ButtonLink>
      <ButtonLink to="/pricing" variant="ghost" onClick={onNavigate}>
        Pricing
      </ButtonLink>
      {hasStories() && (
        <ButtonLink to="/stories" variant="ghost" onClick={onNavigate}>
          Stories
        </ButtonLink>
      )}
      <Button
        variant="ghost"
        nativeButton={false}
        onClick={onNavigate}
        render={
          <a
            href="https://docs.promptjuggler.com/"
            target="_blank"
            rel="noreferrer noopener"
          >
            Docs
          </a>
        }
      />
      {!isAuthenticated && (
        <ButtonLink variant="ghost" to="/auth/login" onClick={onNavigate}>
          Sign In
        </ButtonLink>
      )}
      <ButtonLink
        variant="spark"
        className="ml-2"
        {...ctaProps}
        onClick={onNavigate}
      />
    </>
  )
}

export default function Nav() {
  const [open, setOpen] = useState(false)

  return (
    <nav className="sticky top-0 z-50 border-b border-border/40 bg-background/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-250 items-center justify-between px-4 py-2">
        <Link to="/">
          <Logo size={28} className="my-1" />
        </Link>
        {/* Desktop nav */}
        <div className="hidden items-center gap-1 text-muted-foreground sm:flex">
          <NavLinks />
        </div>
        {/* Mobile hamburger */}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger
            render={<IconButton variant="ghost" icon={Menu01Icon} />}
            className="sm:hidden"
          />
          <SheetContent side="right" className="pt-12" showCloseButton>
            <div className="flex flex-col gap-1 px-2 text-muted-foreground">
              <NavLinks
                onNavigate={() => {
                  setOpen(false)
                }}
              />
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  )
}
